/**
 * main.tsx
 * Vite entry point. Mounts React root inside the Office task pane.
 * Does NOT call Office.onReady here — that is handled by useOfficeReady hook.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element not found');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
